import React from "react";
import FirebaseSessionContext from "contexts/FirebaseSessionContext";
import {
  defaultSessionState,
  whenUserLogsInOrLogsOut,
  FirebaseSessionState,
  currentUserIdToken
} from "services/browser/FirebaseWeb";
import { useEffect, useState } from "react";
import { isNil } from "lodash";
import useWhenLoggingInOrOut from "hooks/useWhenLoggingInOrOut";

function useFirebaseSessionState(): FirebaseSessionState {
  const [sessionState, setSessionState] = useState<FirebaseSessionState>(
    defaultSessionState
  );

  function isLoggingOut(user) {
    return sessionState.numLogins >= 1 && isNil(user);
  }

  function getNumLogins(user) {
    return isNil(user) ? sessionState.numLogins : (sessionState.numLogins += 1);
  }

  const whenLoggingInOrOut = useWhenLoggingInOrOut()
  useEffect(
    () => {
        whenUserLogsInOrLogsOut(async user => {
            await whenLoggingInOrOut(user);
            const idToken = await currentUserIdToken();
            setSessionState({
                loggingOut: isLoggingOut(user),
                user,
                userIsLoggedIn: !isNil(user),
                loggedInUserId: user?.uid ?? "",
                loggedInUserEmail: user?.email ?? '',
                sessionInitialized: true,
                numLogins: getNumLogins(user),
                idToken
            });
        });
    },
    []
  );

  return sessionState;
}

const FirebaseSessionProvider = ({ children }) => {
  const firebaseSessionState: FirebaseSessionState = useFirebaseSessionState();
  return (
    <FirebaseSessionContext.Provider value={firebaseSessionState}>
      {children}
    </FirebaseSessionContext.Provider>
  );
};

export default FirebaseSessionProvider;
